import {apiPost, apiGet, apiDelete} from './index'
// 定制学习旅程
const customizedChangeSuger = (params) => apiPost('/api/cj/customized/journey', params)

// 获取疾病列表
const diseaseList = (params) => apiGet('/api/cj/disease', params)

// 定制疾病选择
const customizedChangeDisease = (params) => apiPost(`/api/cj/customized/journey/disease/${params.customizedCode}`, params)

const journeyActivity = (type, key) => apiGet(`/api/cj/customized/journey/activity/${type}/${key}`)

// 获取技术学习列表
const technologyList = (params) => apiGet('/api/cj/technology', params)

// 定制疾病选择
const customizedChangeTechnology = (params) => apiPost(`/api/cj/customized/journey/technology/${params.customizedCode}`, params)

// 获取技术学习列表
const journeyTops = (params) => apiGet(`/api/cj/customized/journey/${params.customizedCode}`, params)

// 获取旅程liebiaos
const journeys = (params) => apiGet(`/api/cj/journey`, params)

// 根据旅程id获取阶段
const stages = (params) => apiGet(`/api/cj/journey/stages/${params.journeyId}`)

const customizedStageCons = (params) => apiGet(`/api/cj/customized/journey`, params)

const employeeHcp = (params) => apiGet(`/api/cj/employeeHcp`, params)

const customizedChangeCourse = (params) => apiPost(`/api/cj/customized/journey/course`, params)
const customizedChangeStudyContent = (params) => apiPost(`/api/cj/customized/journey/course/mobile`, params)

const customizedChangeActivity = (params) => apiPost(`/api/cj/customized/journey/activity`, params)
const deleteCustomizedActivity = (id) => apiDelete(`/api/cj/customized/journey/activity/${id}`)

// 根据旅程id获取阶段
const activityList = (params) => apiGet(`/api/cj/academic/activity`, params)

const customizedChangeCycle = (params) => apiPost(`/api/cj/customized/journey/cycle`, params)

const calendarIndex = (params) => apiGet(`/api/user/study/calendar`, params)

const customizedPush = (params) => apiPost(`/api/cj/customized/journey/push/${params.customizedCode}/${params.multiCode}`, params)

// 获取选择课程列表
const getCourses = (params) => apiGet(`/api/cj/journey/stage/course`, params)

// 获取用户等级
const getUsersRole = (params) => apiGet(`/api/johnson/iep/users/role/${params.userId}`)

const getDetailsByMultiCode = (params) => apiGet(`/api/cj/customized/journey/multiCode`, params)

const getjourneysByMultiCode = (params) => apiGet(`/api/cj/customized/journey/multiCode/${params.multiCode}`)

const checkCJ = (params) => apiGet(`/api/cj/customized/journey/check/${params.multiCode}`)

const selectCjDataBanklistPage = (params) => apiGet(`/api/courses/selectCjDataBanklistPage`, params)

const handleGetDateStatus = (params) => apiGet(`/api/class/user/class/cj/${params.userId}`, params)

const technologyListAll = () => apiGet(`/api/cj/technology/list`)

const customizedUnlockJourney = (params) => apiPost('/api/cj/customized/journey/state/manual/unlock', params)
const customizedUnlockJourneyStage = (params) => apiPost('/api/cj/customized/journey/stage/state/manual/unlock', params)

export {
  customizedUnlockJourneyStage,
  customizedUnlockJourney,
  customizedChangeSuger,
  diseaseList,
  journeyActivity,
  customizedChangeDisease,
  technologyList,
  customizedChangeTechnology,
  journeyTops,
  journeys,
  stages,
  customizedStageCons,
  employeeHcp,
  customizedChangeStudyContent,
  customizedChangeCourse,
  deleteCustomizedActivity,
  customizedChangeActivity,
  activityList,
  customizedChangeCycle,
  calendarIndex,
  customizedPush,
  getCourses,
  getUsersRole,
  getDetailsByMultiCode,
  getjourneysByMultiCode,
  checkCJ,
  selectCjDataBanklistPage,
  handleGetDateStatus,
  technologyListAll
}



// WEBPACK FOOTER //
// ./src/api/cartoJourney.js